import React from "react";
import {MyWorkWrapper} from "./MyWorkElements";

const MyWork = ()=>{
    return <>
        <MyWorkWrapper>
            div
        </MyWorkWrapper>
    </>
}

export default MyWork;
